/**
 * Biblioteca de Campos Pré-Prontos para Eventos
 * Campos comuns já configurados para uso imediato
 */

export const fieldLibrary = {
  // ========================================
  // DADOS PESSOAIS
  // ========================================
  personal: {
    label: 'Dados Pessoais',
    icon: 'bx bx-user',
    fields: [
      {
        id: 'lib_nome_completo',
        label: 'Nome Completo',
        name: 'nome_completo',
        fieldType: { name: 'text', label: 'Text' },
        placeholder: 'Digite seu nome completo',
        required: true,
        category: 'personal'
      },
      {
        id: 'lib_email',
        label: 'E-mail',
        name: 'email',
        fieldType: { name: 'email', label: 'E-mail' },
        placeholder: 'seu@email.com',
        required: true,
        unique: true,
        category: 'personal'
      },
      {
        id: 'lib_telefone',
        label: 'Telefone / WhatsApp',
        name: 'telefone',
        fieldType: { name: 'phone', label: 'Telefone' },
        placeholder: '(11) 99999-9999',
        required: true,
        category: 'personal'
      },
      {
        id: 'lib_cpf',
        label: 'CPF',
        name: 'cpf',
        fieldType: { name: 'cpf', label: 'CPF' },
        placeholder: '000.000.000-00',
        required: true,
        unique: true,
        category: 'personal'
      },
      {
        id: 'lib_rg',
        label: 'RG',
        name: 'rg',
        fieldType: { name: 'rg', label: 'RG' },
        placeholder: 'Digite seu RG',
        required: false,
        category: 'personal'
      },
      {
        id: 'lib_data_nascimento',
        label: 'Data de Nascimento',
        name: 'data_nascimento',
        fieldType: { name: 'birthdate', label: 'Data de Nascimento' },
        placeholder: 'DD/MM/AAAA',
        required: false,
        category: 'personal'
      },
      {
        id: 'lib_genero',
        label: 'Gênero',
        name: 'genero',
        fieldType: { name: 'select', label: 'Select' },
        placeholder: 'Selecione seu gênero',
        required: false,
        options: [
          { label: 'Masculino', value: 'Masculino' },
          { label: 'Feminino', value: 'Feminino' },
          { label: 'Não-binário', value: 'Não-binário' },
          { label: 'Prefiro não informar', value: 'Prefiro não informar' }
        ],
        category: 'personal'
      },
      {
        id: 'lib_estado_civil',
        label: 'Estado Civil',
        name: 'estado_civil',
        fieldType: { name: 'select', label: 'Select' },
        placeholder: 'Selecione',
        required: false,
        options: [
          { label: 'Solteiro(a)', value: 'Solteiro(a)' },
          { label: 'Casado(a)', value: 'Casado(a)' },
          { label: 'Divorciado(a)', value: 'Divorciado(a)' },
          { label: 'Viúvo(a)', value: 'Viúvo(a)' },
          { label: 'União Estável', value: 'União Estável' }
        ],
        category: 'personal'
      }
    ]
  },

  // ========================================
  // DADOS PROFISSIONAIS
  // ========================================
  professional: {
    label: 'Dados Profissionais',
    icon: 'bx bx-briefcase',
    fields: [
      {
        id: 'lib_empresa',
        label: 'Empresa',
        name: 'empresa',
        fieldType: { name: 'text', label: 'Text' },
        placeholder: 'Nome da empresa',
        required: false,
        category: 'professional'
      },
      {
        id: 'lib_cnpj',
        label: 'CNPJ',
        name: 'cnpj',
        fieldType: { name: 'cnpj', label: 'CNPJ' },
        placeholder: '00.000.000/0000-00',
        required: false,
        category: 'professional'
      },
      {
        id: 'lib_cargo',
        label: 'Cargo',
        name: 'cargo',
        fieldType: { name: 'text', label: 'Text' },
        placeholder: 'Seu cargo na empresa',
        required: false,
        category: 'professional'
      },
      {
        id: 'lib_departamento',
        label: 'Departamento / Área',
        name: 'departamento',
        fieldType: { name: 'text', label: 'Text' },
        placeholder: 'Ex: Marketing, TI, Comercial',
        required: false,
        category: 'professional'
      },
      {
        id: 'lib_segmento',
        label: 'Segmento de Atuação',
        name: 'segmento',
        fieldType: { name: 'select', label: 'Select' },
        placeholder: 'Selecione o segmento',
        required: false,
        options: [
          { label: 'Tecnologia', value: 'Tecnologia' },
          { label: 'Saúde', value: 'Saúde' },
          { label: 'Educação', value: 'Educação' },
          { label: 'Financeiro', value: 'Financeiro' },
          { label: 'Varejo', value: 'Varejo' },
          { label: 'Indústria', value: 'Indústria' },
          { label: 'Serviços', value: 'Serviços' },
          { label: 'Governo', value: 'Governo' },
          { label: 'Outro', value: 'Outro' }
        ],
        category: 'professional'
      },
      {
        id: 'lib_linkedin',
        label: 'LinkedIn',
        name: 'linkedin',
        fieldType: { name: 'text', label: 'Text' },
        placeholder: 'https://linkedin.com/in/seu-perfil',
        required: false,
        category: 'professional'
      }
    ]
  },

  // ========================================
  // ENDEREÇO
  // ========================================
  address: {
    label: 'Endereço',
    icon: 'bx bx-map',
    fields: [
      {
        id: 'lib_cep',
        label: 'CEP',
        name: 'cep',
        fieldType: { name: 'cep', label: 'CEP' },
        placeholder: '00000-000',
        required: false,
        help_text: 'Digite o CEP para preenchimento automático',
        category: 'address'
      },
      {
        id: 'lib_endereco',
        label: 'Endereço',
        name: 'endereco',
        fieldType: { name: 'text', label: 'Text' },
        placeholder: 'Rua, Avenida...',
        required: false,
        category: 'address'
      },
      {
        id: 'lib_numero',
        label: 'Número',
        name: 'numero',
        fieldType: { name: 'text', label: 'Text' },
        placeholder: 'Nº',
        required: false,
        width: '30%',
        category: 'address'
      },
      {
        id: 'lib_complemento',
        label: 'Complemento',
        name: 'complemento',
        fieldType: { name: 'text', label: 'Text' },
        placeholder: 'Apto, Sala, Bloco...',
        required: false,
        width: '70%',
        category: 'address'
      },
      {
        id: 'lib_bairro',
        label: 'Bairro',
        name: 'bairro',
        fieldType: { name: 'text', label: 'Text' },
        placeholder: 'Bairro',
        required: false,
        category: 'address'
      },
      {
        id: 'lib_cidade',
        label: 'Cidade',
        name: 'cidade',
        fieldType: { name: 'text', label: 'Text' },
        placeholder: 'Cidade',
        required: false,
        category: 'address'
      },
      {
        id: 'lib_estado',
        label: 'Estado',
        name: 'estado',
        fieldType: { name: 'state', label: 'Estado' },
        placeholder: 'Selecione o estado',
        required: false,
        category: 'address'
      },
      {
        id: 'lib_pais',
        label: 'País',
        name: 'pais',
        fieldType: { name: 'text', label: 'Text' },
        placeholder: 'País',
        default_value: 'Brasil',
        required: false,
        category: 'address'
      }
    ]
  },

  // ========================================
  // VESTUÁRIO / BRINDES
  // ========================================
  apparel: {
    label: 'Vestuário / Brindes',
    icon: 'bx bx-closet',
    fields: [
      {
        id: 'lib_tamanho_camiseta',
        label: 'Tamanho de Camiseta',
        name: 'tamanho_camiseta',
        fieldType: { name: 'select', label: 'Select' },
        placeholder: 'Selecione o tamanho',
        required: false,
        options: [
          { label: 'PP', value: 'PP' },
          { label: 'P', value: 'P' },
          { label: 'M', value: 'M' },
          { label: 'G', value: 'G' },
          { label: 'GG', value: 'GG' },
          { label: 'XGG', value: 'XGG' },
          { label: 'XXGG', value: 'XXGG' }
        ],
        category: 'apparel'
      },
      {
        id: 'lib_tamanho_calcado',
        label: 'Tamanho de Calçado',
        name: 'tamanho_calcado',
        fieldType: { name: 'select', label: 'Select' },
        placeholder: 'Selecione o tamanho',
        required: false,
        options: [
          { label: '34', value: '34' },
          { label: '35', value: '35' },
          { label: '36', value: '36' },
          { label: '37', value: '37' },
          { label: '38', value: '38' },
          { label: '39', value: '39' },
          { label: '40', value: '40' },
          { label: '41', value: '41' },
          { label: '42', value: '42' },
          { label: '43', value: '43' },
          { label: '44', value: '44' },
          { label: '45', value: '45' }
        ],
        category: 'apparel'
      },
      {
        id: 'lib_tamanho_blazer',
        label: 'Tamanho de Blazer/Paletó',
        name: 'tamanho_blazer',
        fieldType: { name: 'select', label: 'Select' },
        placeholder: 'Selecione o tamanho',
        required: false,
        options: [
          { label: '38', value: '38' },
          { label: '40', value: '40' },
          { label: '42', value: '42' },
          { label: '44', value: '44' },
          { label: '46', value: '46' },
          { label: '48', value: '48' },
          { label: '50', value: '50' },
          { label: '52', value: '52' },
          { label: '54', value: '54' }
        ],
        category: 'apparel'
      }
    ]
  },

  // ========================================
  // ALIMENTAÇÃO
  // ========================================
  food: {
    label: 'Alimentação',
    icon: 'bx bx-restaurant',
    fields: [
      {
        id: 'lib_restricao_alimentar',
        label: 'Restrição Alimentar',
        name: 'restricao_alimentar',
        fieldType: { name: 'multiselect', label: 'Multi Select' },
        placeholder: 'Selecione suas restrições',
        required: false,
        options: [
          { label: 'Nenhuma restrição', value: 'Nenhuma restrição' },
          { label: 'Vegetariano', value: 'Vegetariano' },
          { label: 'Vegano', value: 'Vegano' },
          { label: 'Sem glúten', value: 'Sem glúten' },
          { label: 'Sem lactose', value: 'Sem lactose' },
          { label: 'Kosher', value: 'Kosher' },
          { label: 'Halal', value: 'Halal' },
          { label: 'Alergia a frutos do mar', value: 'Alergia a frutos do mar' },
          { label: 'Alergia a amendoim', value: 'Alergia a amendoim' },
          { label: 'Diabético', value: 'Diabético' },
          { label: 'Outro', value: 'Outro' }
        ],
        category: 'food'
      },
      {
        id: 'lib_restricao_alimentar_detalhe',
        label: 'Detalhes da Restrição Alimentar',
        name: 'restricao_alimentar_detalhe',
        fieldType: { name: 'textarea', label: 'Textarea' },
        placeholder: 'Descreva detalhes sobre sua restrição alimentar',
        required: false,
        category: 'food'
      },
      {
        id: 'lib_preferencia_almoco',
        label: 'Preferência para Almoço',
        name: 'preferencia_almoco',
        fieldType: { name: 'radio', label: 'Radio' },
        required: false,
        options: [
          { label: 'Carne', value: 'Carne' },
          { label: 'Frango', value: 'Frango' },
          { label: 'Peixe', value: 'Peixe' },
          { label: 'Vegetariano', value: 'Vegetariano' }
        ],
        category: 'food'
      }
    ]
  },

  // ========================================
  // TRANSPORTE AÉREO
  // ========================================
  flight: {
    label: 'Transporte Aéreo',
    icon: 'bx bx-plane',
    fields: [
      {
        id: 'lib_necessita_aereo',
        label: 'Necessita de Passagem Aérea?',
        name: 'necessita_aereo',
        fieldType: { name: 'radio', label: 'Radio' },
        required: false,
        options: [
          { label: 'Sim', value: 'Sim' },
          { label: 'Não', value: 'Não' }
        ],
        category: 'flight'
      },
      {
        id: 'lib_aeroporto_origem',
        label: 'Aeroporto de Origem',
        name: 'aeroporto_origem',
        fieldType: { name: 'text', label: 'Text' },
        placeholder: 'Ex: GRU - Guarulhos',
        required: false,
        category: 'flight'
      },
      {
        id: 'lib_data_ida',
        label: 'Data de Ida',
        name: 'data_voo_ida',
        fieldType: { name: 'date', label: 'Date' },
        placeholder: 'Selecione a data',
        required: false,
        category: 'flight'
      },
      {
        id: 'lib_horario_ida',
        label: 'Horário Preferido (Ida)',
        name: 'horario_ida',
        fieldType: { name: 'select', label: 'Select' },
        placeholder: 'Selecione o período',
        required: false,
        options: [
          { label: 'Manhã (06h - 12h)', value: 'Manhã (06h - 12h)' },
          { label: 'Tarde (12h - 18h)', value: 'Tarde (12h - 18h)' },
          { label: 'Noite (18h - 00h)', value: 'Noite (18h - 00h)' },
          { label: 'Sem preferência', value: 'Sem preferência' }
        ],
        category: 'flight'
      },
      {
        id: 'lib_data_volta',
        label: 'Data de Volta',
        name: 'data_voo_volta',
        fieldType: { name: 'date', label: 'Date' },
        placeholder: 'Selecione a data',
        required: false,
        category: 'flight'
      },
      {
        id: 'lib_horario_volta',
        label: 'Horário Preferido (Volta)',
        name: 'horario_volta',
        fieldType: { name: 'select', label: 'Select' },
        placeholder: 'Selecione o período',
        required: false,
        options: [
          { label: 'Manhã (06h - 12h)', value: 'Manhã (06h - 12h)' },
          { label: 'Tarde (12h - 18h)', value: 'Tarde (12h - 18h)' },
          { label: 'Noite (18h - 00h)', value: 'Noite (18h - 00h)' },
          { label: 'Sem preferência', value: 'Sem preferência' }
        ],
        category: 'flight'
      },
      {
        id: 'lib_programa_milhagem',
        label: 'Programa de Milhagem',
        name: 'programa_milhagem',
        fieldType: { name: 'text', label: 'Text' },
        placeholder: 'Número do cartão fidelidade',
        required: false,
        category: 'flight'
      },
      {
        id: 'lib_assento_preferido',
        label: 'Preferência de Assento',
        name: 'assento_preferido',
        fieldType: { name: 'radio', label: 'Radio' },
        required: false,
        options: [
          { label: 'Janela', value: 'Janela' },
          { label: 'Corredor', value: 'Corredor' },
          { label: 'Sem preferência', value: 'Sem preferência' }
        ],
        category: 'flight'
      }
    ]
  },

  // ========================================
  // HOSPEDAGEM
  // ========================================
  accommodation: {
    label: 'Hospedagem',
    icon: 'bx bx-hotel',
    fields: [
      {
        id: 'lib_necessita_hospedagem',
        label: 'Necessita de Hospedagem?',
        name: 'necessita_hospedagem',
        fieldType: { name: 'radio', label: 'Radio' },
        required: false,
        options: [
          { label: 'Sim', value: 'Sim' },
          { label: 'Não', value: 'Não' }
        ],
        category: 'accommodation'
      },
      {
        id: 'lib_data_checkin',
        label: 'Data de Check-in',
        name: 'data_checkin',
        fieldType: { name: 'date', label: 'Date' },
        placeholder: 'Selecione a data',
        required: false,
        category: 'accommodation'
      },
      {
        id: 'lib_data_checkout',
        label: 'Data de Check-out',
        name: 'data_checkout',
        fieldType: { name: 'date', label: 'Date' },
        placeholder: 'Selecione a data',
        required: false,
        category: 'accommodation'
      },
      {
        id: 'lib_tipo_quarto',
        label: 'Tipo de Quarto',
        name: 'tipo_quarto',
        fieldType: { name: 'select', label: 'Select' },
        placeholder: 'Selecione o tipo',
        required: false,
        options: [
          { label: 'Single', value: 'Single' },
          { label: 'Double', value: 'Double' },
          { label: 'Twin', value: 'Twin' },
          { label: 'Suíte', value: 'Suíte' }
        ],
        category: 'accommodation'
      },
      {
        id: 'lib_compartilhar_quarto',
        label: 'Aceita Compartilhar Quarto?',
        name: 'compartilhar_quarto',
        fieldType: { name: 'radio', label: 'Radio' },
        required: false,
        options: [
          { label: 'Sim', value: 'Sim' },
          { label: 'Não', value: 'Não' }
        ],
        category: 'accommodation'
      },
      {
        id: 'lib_nome_acompanhante_quarto',
        label: 'Nome do Acompanhante de Quarto',
        name: 'nome_acompanhante_quarto',
        fieldType: { name: 'text', label: 'Text' },
        placeholder: 'Nome completo do acompanhante',
        required: false,
        category: 'accommodation'
      }
    ]
  },

  // ========================================
  // DOCUMENTOS
  // ========================================
  documents: {
    label: 'Documentos',
    icon: 'bx bx-file',
    fields: [
      {
        id: 'lib_upload_documento',
        label: 'Upload de Documento (RG/CNH)',
        name: 'documento_identidade',
        fieldType: { name: 'file', label: 'File Upload' },
        placeholder: 'Selecione o arquivo',
        required: false,
        help_text: 'Formatos aceitos: PDF, JPG, PNG. Máx: 5MB',
        category: 'documents'
      },
      {
        id: 'lib_upload_passaporte',
        label: 'Upload de Passaporte',
        name: 'passaporte',
        fieldType: { name: 'file', label: 'File Upload' },
        placeholder: 'Selecione o arquivo',
        required: false,
        help_text: 'Página de identificação do passaporte. Formatos: PDF, JPG, PNG',
        category: 'documents'
      },
      {
        id: 'lib_numero_passaporte',
        label: 'Número do Passaporte',
        name: 'numero_passaporte',
        fieldType: { name: 'text', label: 'Text' },
        placeholder: 'Digite o número do passaporte',
        required: false,
        category: 'documents'
      },
      {
        id: 'lib_validade_passaporte',
        label: 'Validade do Passaporte',
        name: 'validade_passaporte',
        fieldType: { name: 'date', label: 'Date' },
        placeholder: 'Selecione a data',
        required: false,
        category: 'documents'
      },
      {
        id: 'lib_upload_foto',
        label: 'Foto para Credencial',
        name: 'foto_credencial',
        fieldType: { name: 'image', label: 'Image Upload' },
        placeholder: 'Selecione a foto',
        required: false,
        help_text: 'Foto 3x4 com fundo branco. Formatos: JPG, PNG',
        category: 'documents'
      },
      {
        id: 'lib_upload_comprovante',
        label: 'Comprovante de Residência',
        name: 'comprovante_residencia',
        fieldType: { name: 'file', label: 'File Upload' },
        placeholder: 'Selecione o arquivo',
        required: false,
        help_text: 'Conta de luz, água ou telefone. Máx: 5MB',
        category: 'documents'
      },
      {
        id: 'lib_upload_curriculo',
        label: 'Currículo',
        name: 'curriculo',
        fieldType: { name: 'file', label: 'File Upload' },
        placeholder: 'Selecione o arquivo',
        required: false,
        help_text: 'Formato: PDF. Máx: 5MB',
        category: 'documents'
      }
    ]
  },

  // ========================================
  // ACESSIBILIDADE
  // ========================================
  accessibility: {
    label: 'Acessibilidade',
    icon: 'bx bx-accessibility',
    fields: [
      {
        id: 'lib_necessidade_especial',
        label: 'Possui Necessidade Especial?',
        name: 'necessidade_especial',
        fieldType: { name: 'radio', label: 'Radio' },
        required: false,
        options: [
          { label: 'Sim', value: 'Sim' },
          { label: 'Não', value: 'Não' }
        ],
        category: 'accessibility'
      },
      {
        id: 'lib_tipo_necessidade',
        label: 'Tipo de Necessidade',
        name: 'tipo_necessidade',
        fieldType: { name: 'multiselect', label: 'Multi Select' },
        placeholder: 'Selecione as opções',
        required: false,
        options: [
          { label: 'Cadeirante', value: 'Cadeirante' },
          { label: 'Mobilidade reduzida', value: 'Mobilidade reduzida' },
          { label: 'Deficiência visual', value: 'Deficiência visual' },
          { label: 'Deficiência auditiva', value: 'Deficiência auditiva' },
          { label: 'Intérprete de Libras', value: 'Intérprete de Libras' },
          { label: 'Outra', value: 'Outra' }
        ],
        category: 'accessibility'
      },
      {
        id: 'lib_detalhe_necessidade',
        label: 'Detalhes da Necessidade',
        name: 'detalhe_necessidade',
        fieldType: { name: 'textarea', label: 'Textarea' },
        placeholder: 'Descreva suas necessidades para melhor atendimento',
        required: false,
        category: 'accessibility'
      }
    ]
  },

  // ========================================
  // EMERGÊNCIA
  // ========================================
  emergency: {
    label: 'Contato de Emergência',
    icon: 'bx bx-phone-call',
    fields: [
      {
        id: 'lib_contato_emergencia_nome',
        label: 'Nome do Contato de Emergência',
        name: 'contato_emergencia_nome',
        fieldType: { name: 'text', label: 'Text' },
        placeholder: 'Nome completo',
        required: false,
        category: 'emergency'
      },
      {
        id: 'lib_contato_emergencia_telefone',
        label: 'Telefone de Emergência',
        name: 'contato_emergencia_telefone',
        fieldType: { name: 'phone', label: 'Telefone' },
        placeholder: '(11) 99999-9999',
        required: false,
        category: 'emergency'
      },
      {
        id: 'lib_contato_emergencia_parentesco',
        label: 'Grau de Parentesco',
        name: 'contato_emergencia_parentesco',
        fieldType: { name: 'select', label: 'Select' },
        placeholder: 'Selecione',
        required: false,
        options: [
          { label: 'Cônjuge', value: 'Cônjuge' },
          { label: 'Pai/Mãe', value: 'Pai/Mãe' },
          { label: 'Filho(a)', value: 'Filho(a)' },
          { label: 'Irmão(ã)', value: 'Irmão(ã)' },
          { label: 'Amigo(a)', value: 'Amigo(a)' },
          { label: 'Outro', value: 'Outro' }
        ],
        category: 'emergency'
      }
    ]
  },

  // ========================================
  // EVENTO / PARTICIPAÇÃO
  // ========================================
  event: {
    label: 'Evento / Participação',
    icon: 'bx bx-calendar-event',
    fields: [
      {
        id: 'lib_como_soube',
        label: 'Como soube do evento?',
        name: 'como_soube',
        fieldType: { name: 'select', label: 'Select' },
        placeholder: 'Selecione uma opção',
        required: false,
        options: [
          { label: 'Redes Sociais', value: 'Redes Sociais' },
          { label: 'E-mail marketing', value: 'E-mail marketing' },
          { label: 'Indicação de amigo', value: 'Indicação de amigo' },
          { label: 'Site/Blog', value: 'Site/Blog' },
          { label: 'Google', value: 'Google' },
          { label: 'LinkedIn', value: 'LinkedIn' },
          { label: 'Outro', value: 'Outro' }
        ],
        category: 'event'
      },
      {
        id: 'lib_interesse_temas',
        label: 'Temas de Interesse',
        name: 'interesse_temas',
        fieldType: { name: 'multiselect', label: 'Multi Select' },
        placeholder: 'Selecione os temas',
        required: false,
        options: [
          { label: 'Inovação', value: 'Inovação' },
          { label: 'Tecnologia', value: 'Tecnologia' },
          { label: 'Marketing', value: 'Marketing' },
          { label: 'Vendas', value: 'Vendas' },
          { label: 'Gestão', value: 'Gestão' },
          { label: 'Liderança', value: 'Liderança' },
          { label: 'Networking', value: 'Networking' }
        ],
        category: 'event'
      },
      {
        id: 'lib_expectativa',
        label: 'Qual sua expectativa para o evento?',
        name: 'expectativa',
        fieldType: { name: 'textarea', label: 'Textarea' },
        placeholder: 'Conte-nos o que espera do evento',
        required: false,
        category: 'event'
      },
      {
        id: 'lib_participou_edicoes',
        label: 'Já participou de edições anteriores?',
        name: 'participou_edicoes',
        fieldType: { name: 'radio', label: 'Radio' },
        required: false,
        options: [
          { label: 'Sim', value: 'Sim' },
          { label: 'Não, é minha primeira vez', value: 'Não, é minha primeira vez' }
        ],
        category: 'event'
      }
    ]
  },

  // ========================================
  // TERMOS E ACEITES
  // ========================================
  terms: {
    label: 'Termos e Aceites',
    icon: 'bx bx-check-shield',
    fields: [
      {
        id: 'lib_aceite_termos',
        label: 'Aceito os Termos de Uso',
        name: 'aceite_termos',
        fieldType: { name: 'terms', label: 'Terms' },
        required: true,
        options: [
          { label: 'Li e aceito os Termos de Uso e Política de Privacidade', value: 'Li e aceito os Termos de Uso e Política de Privacidade' }
        ],
        config: { link_text: '', link_url: '' },
        category: 'terms'
      },
      {
        id: 'lib_aceite_imagem',
        label: 'Autorização de Uso de Imagem',
        name: 'aceite_imagem',
        fieldType: { name: 'checkbox', label: 'Checkbox' },
        required: false,
        options: [
          { label: 'Autorizo o uso de minha imagem em fotos e vídeos do evento', value: 'Autorizo o uso de minha imagem em fotos e vídeos do evento' }
        ],
        category: 'terms'
      },
      {
        id: 'lib_aceite_newsletter',
        label: 'Newsletter',
        name: 'aceite_newsletter',
        fieldType: { name: 'checkbox', label: 'Checkbox' },
        required: false,
        options: [
          { label: 'Desejo receber novidades e comunicações por e-mail', value: 'Desejo receber novidades e comunicações por e-mail' }
        ],
        category: 'terms'
      },
      {
        id: 'lib_aceite_whatsapp',
        label: 'Comunicação por WhatsApp',
        name: 'aceite_whatsapp',
        fieldType: { name: 'checkbox', label: 'Checkbox' },
        required: false,
        options: [
          { label: 'Autorizo contato via WhatsApp', value: 'Autorizo contato via WhatsApp' }
        ],
        category: 'terms'
      }
    ]
  },

  // ========================================
  // PERSONALIZADOS
  // ========================================
  custom: {
    label: 'Personalizados',
    icon: 'bx bx-customize',
    fields: [
      {
        id: 'lib_fake_ticket',
        label: 'Bilhete / Ingresso (Visual)',
        name: 'fake_ticket',
        fieldType: { name: 'fake_ticket', label: 'Bilhete Fake' },
        required: false,
        category: 'custom',
        config: {
          ticket_title: 'Acesso Completo — Evento 2025',
          ticket_value: '450,00',
          ticket_validity: '15 Mar 2025',
          ticket_type: 'Presencial'
        }
      },
      {
        id: 'lib_disclaimer',
        label: 'Disclaimer',
        name: 'disclaimer',
        fieldType: { name: 'disclaimer', label: 'Disclaimer' },
        required: false,
        category: 'custom',
        config: {
          title: 'Como gerar seu código de participação',
          body: 'Para prosseguir com a inscrição, você precisará de um código de participação válido. Siga os passos abaixo para obtê-lo:',
          color: 'amber',
          show_steps: true,
          steps: [
            { text: 'Acesse a plataforma de convites com o mesmo e-mail corporativo informado acima.' },
            { text: 'No menu lateral, clique em "Meus Eventos" e localize o evento desejado.' },
            { text: 'Clique em "Gerar Código" e copie o código alfanumérico de 8 dígitos exibido na tela.' },
            { text: 'Cole o código no campo abaixo. Caso tenha dificuldades, entre em contato com o suporte do evento.' }
          ]
        }
      },
      {
        id: 'lib_instrucoes',
        label: 'Instruções',
        name: 'instrucoes',
        fieldType: { name: 'instrucoes', label: 'Instruções' },
        required: false,
        category: 'custom',
        config: {
          content: '<p>Insira aqui o texto de instruções para o participante.</p>',
          color: 'green',
          require_acceptance: false,
          acceptance_label: 'Li e estou ciente de todas as instruções acima.',
          show_read_hint: false,
          read_hint_text: 'Leia todas as instruções até o final para prosseguir.'
        }
      }
    ]
  }
}

/**
 * Retorna todas as categorias disponíveis
 */
export const getCategories = () => {
  return Object.keys(fieldLibrary).map(key => ({
    key,
    label: fieldLibrary[key].label,
    icon: fieldLibrary[key].icon,
    count: fieldLibrary[key].fields.length
  }))
}

/**
 * Retorna todos os campos de uma categoria
 */
export const getFieldsByCategory = (category) => {
  return fieldLibrary[category]?.fields || []
}

/**
 * Busca campos por termo
 */
export const searchFields = (term) => {
  const results = []
  const searchLower = term.toLowerCase()

  Object.keys(fieldLibrary).forEach(category => {
    fieldLibrary[category].fields.forEach(field => {
      if (
        field.label.toLowerCase().includes(searchLower) ||
        field.name.toLowerCase().includes(searchLower)
      ) {
        results.push({
          ...field,
          categoryKey: category,
          categoryLabel: fieldLibrary[category].label
        })
      }
    })
  })

  return results
}

/**
 * Retorna todos os campos de todas as categorias
 */
export const getAllFields = () => {
  const all = []
  Object.keys(fieldLibrary).forEach(category => {
    fieldLibrary[category].fields.forEach(field => {
      all.push({
        ...field,
        categoryKey: category,
        categoryLabel: fieldLibrary[category].label
      })
    })
  })
  return all
}

export default fieldLibrary
